module.exports = __webpack_public_path__ + "img/404-error.a8f7ab88.png";